export const da = {
    'nav.today': "Oversigt i Dag",
    'nav.calendar': "Efterspørgselskalender",
    'nav.rates': "Priser & Regler",
    'nav.automation': "Automatiseringscenter",
    'nav.audit': "Audit Log",
    'nav.settings': "Indstillinger",
    'sidebar.status': "Tilsluttet",
    'stat.occupancy': "Belægning",
    'stat.adr': "Gns. Pris (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Est. Omsætning",
    'stat.trend.vsLastWeek': "vs Sidste Uge",
    'stat.trend.onPace': "På rette kurs",
    'dashboard.actions.title': "Anbefalede Handlinger",
    'dashboard.actions.empty': "Ingen handlinger fundet.",
    'filter.all': "Alle",
    'filter.pricing': "Prissætning",
    'filter.restriction': "Restriktioner",
    'action.approve': "Godkend",
    'action.reject': "Afvis",
    'action.risk.low': "lav risiko",
    'action.risk.medium': "mellem risiko",
    'action.risk.high': "høj risiko",
    'action.label.current': "Nuværende",
    'action.label.proposed': "Foreslået",
    'action.metric.impact': "Effekt",
    'action.metric.why': "Hvorfor",
    'action.status.executed': "Auto-Udført",
    'header.search': "Søg...",
    'header.logout': "Log ud",
    'auto.level.title': "Autopilot Niveau",
    'auto.level.manual': "Manuel",
    'auto.level.manual.desc': "Du godkender hver enkelt anbefaling.",
    'auto.level.assisted': "Assisteret",
    'auto.level.assisted.desc': "Auto-godkend lav risiko. Gennemgå store ændringer.",
    'auto.level.auto': "Fuldautomatisk",
    'auto.level.auto.desc': "AI styrer priser 24/7 inden for dine grænser.",
    'auto.level.active': "Aktiv",
    'auto.guardrails.title': "Sikkerhedsgrænser",
    'auto.guardrails.maxIncrease': "Maks. Daglig Stigning",
    'auto.guardrails.maxIncrease.desc': "Undgå prichok.",
    'auto.guardrails.maxDecrease': "Maks. Daglig Fald",
    'auto.guardrails.maxDecrease.desc': "Undgå for lave priser.",
    'auto.guardrails.minRate': "Minimumspris",
    'auto.guardrails.minRate.desc': "Sælg aldrig under denne pris (Netto).",
    'auto.emergency.title': "Nødkontrol",
    'auto.emergency.label': "Nødstop",
    'auto.emergency.desc': "Sæt al automatisering på pause straks.",
    'auto.emergency.btn': "PAUSE SYSTEM",
    'rates.filter.all': "Alle Værelsestyper",
    'rates.filter.next14': "Næste 14 Dage",
    'rates.export': "Eksportér",
    'audit.table.time': "Tid",
    'audit.table.actor': "Bruger",
    'audit.table.category': "Kategori",
    'audit.table.action': "Handling",
    'audit.table.details': "Detaljer",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS Forbindelse",
    'settings.pms.connected': "Forbundet til",
    'settings.pms.disconnect': "Afbryd",
    'settings.account.title': "Konto",
    'settings.account.role': "Rolle",
    'settings.restart': "Genstart Onboarding",
    'onboard.title': "Forbind PMS",
    'onboard.desc': "Vælg dit PMS for at synkronisere.",
    'onboard.connecting': "Forbinder...",
    'onboard.connect': "Forbind",
    'onboard.success.title': "Opsætning Fuldført!",
    'onboard.success.desc': "**SynthHotel Berlin** er nu synkroniseret.",
    'onboard.success.sub': "Importerede 3 værelsestyper, 14 prisplaner og 243 bookinger.",
    'onboard.btn.dashboard': "Gå til Dashboard",
    'action.dynamic.weekend.title': "Hæv Pris for Weekend",
    'action.dynamic.weekend.desc': "Belægning > 75% Lørdag, stærk efterspørgsel (+12 værelser på 24t).",
    'action.dynamic.minstay.title': "Aktivér Min. Ophold 2 Nætter",
    'action.dynamic.minstay.desc': "Taylor Swift koncert. Undgå 1-nats ophold.",
    'action.dynamic.distress.title': "Sænk Pris (Lav Efterspørgsel)",
    'action.dynamic.distress.desc': "Belægning 35% næste Tirsdag. Konkurrenter sænkede med 10€.",
    'action.dynamic.gap.title': "Fyld Hul: Fjern CTA",
    'action.dynamic.gap.desc': "Hul på én nat. Fjern 'Lukket for Ankomst' for at sælge.",
};
